//src/app/features/dashboard/admin/AdminDashboard.tsx
import { useState } from 'react';
import ClientsAccountantsStats from './stats/ClientsAccountantsStats';

import { DashboardContainerHeader } from 'app/layout/dashboardLayout/BoxLayout';
import YearSelector from '../shared/YearSelector';
import EngagementLetterStats from './stats/EngagementLetterStats';
import TaxReturnsStats from './stats/TaxReturnsStats';
import TaxReturnRevenue from './stats/TaxReturnRevenue';

const AdminDashboard = () => {
  const [year, setYear] = useState(() => new Date().getFullYear());

  return (
    <>
      <DashboardContainerHeader title="Insights" />
      <ClientsAccountantsStats />
      <div className="flex justify-end items-center gap-2 p-4 md-max:mb-2">
        <span className="text-gray-dark font-medium">Year</span>
        <YearSelector year={year} onChange={setYear} />
      </div>
      <TaxReturnsStats year={year} />
      <div className="flex flex-wrap">
        <EngagementLetterStats year={year} />
        <TaxReturnRevenue year={year} />
      </div>
    </>
  );
};

export default AdminDashboard;
